import { useState, useEffect } from 'react';
import axios from 'axios';

const Statistics = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios.get('/api/statistics')
            .then(response => {
                if (response.data.error_code === 200) {
                    setData(response.data.data);
                } else {
                    console.error('Error fetching statistics:', response.data.message);
                }
            })
            .catch(error => {
                console.error('Error fetching statistics:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [])

    return(
        <>
            <h3 style={{marginBottom: "35px"}}>Dashboard</h3>
            <div className='dashboard-page-container'>
                <div className='dashboard-card'>
                    <h4>Total Parcels</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_parcels}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Users</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_users}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Pending Delivery</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_pending_delivery}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Sent Delivery</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_sent_delivery}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Delivery</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_delivery}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Parcels in Warehouse</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_parcels_warehouse}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Parcels on Way</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_parcels_on_way}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Parcels Arrived</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_parcels_arrived}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Parcels Taken</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_parcels_taken}</p>
                </div>
                <div className='dashboard-card'>
                    <h4>Total Amount</h4>
                    <p>{loading ? <div className="loader"></div> : data.total_amount}₾</p>
                </div>
            </div>
        </>
    )
}

export default Statistics;